import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { ViteSSG } from 'vite-ssg';

import App from '#/App.vue';
import { initAnalytics } from '#/lib/analytics';
import { queryClient } from '#/lib/queryClient';
import { registerAuthGuard, routes, scrollBehavior } from '#/router';
import { registerAnalytics } from '#/router/analytics';

import '#/assets/tailwind.css';

/**
 * 진입점 — vite-ssg(SSG) 로 공개 페이지(홈 리다이렉트·약관)를 빌드 타임 프리렌더한다.
 *
 * ViteSSG 가 자동 처리하므로 여기서 직접 하지 않는 것:
 *  - 라우터 생성·등록: routes/scrollBehavior 만 넘기면 빌드=memory·브라우저=history 로 ViteSSG 가 만든다.
 *  - head(@unhead/vue) 등록: ViteSSG 가 createHead 를 자동 use 한다(중복 등록 방지). useHead 는 그대로 동작.
 *  - app.mount: ViteSSG 가 수화(hydration)/마운트를 담당.
 *
 * setup 콜백(fn)에서는 앱 스코프 플러그인(Pinia·VueQuery)만 등록한다. 문서 타이틀은 여기서 건드리지 않는다 —
 * 라우트 meta.title 기반 `useRouteHead`(App.vue) 가 SSoT.
 */
export const createApp = ViteSSG(App, { routes, scrollBehavior }, ({ app, router, isClient }) => {
  app.use(createPinia());
  app.use(VueQueryPlugin, { queryClient });

  // 인증 가드·GA4 는 브라우저에서만 — 빌드 타임(SSR)엔 API·document 접근이 없어야 한다.
  if (isClient) {
    registerAuthGuard(router);
    // GA4(마케팅 유입 분석) — 측정 ID 미설정(dev)이면 스크립트를 주입하지 않아 통째로 no-op 이 된다.
    // 첫 afterEach 가 발화하기 전에 초기화해야 랜딩 페이지뷰가 유실되지 않는다.
    initAnalytics();
    registerAnalytics(router);
  }
});
